import { Box, Image, Text } from '@domain-group/suit-theme'

import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons'

import DashboardSearch from '@components/DashboardSearch'

import backgroundImageUrl from './assets/backgroundImageUrl.jpg'

export const icon = faMagnifyingGlass

export const configOptions = () => {}

interface DashboardSearchBoxProps {
  editing: boolean,
  parentId: string,
}

const DashboardSearchBox = (props: DashboardSearchBoxProps) => {
  const { editing, parentId } = props

  return (
    <Box
      backgroundColor={editing ? 'white' : 'none'}
      borderTop={editing ? '1px solid' : 'none'}
      borderColor="lineColor"
      padding={editing ? 'large' : 0}
    >
      <Image
        // @ts-expect-error TS2322
        background="red"
        borderRadius={5}
        height={250}
        url={backgroundImageUrl}
      >
        <Box
          alignItems="center"
          backgroundColor="rgba(0, 0, 0, 0.55)"
          borderRadius={5}
          flexDirection="column"
          height="100%"
          justifyContent="center"
          padding="xlarge"
        >
          <Text color="white" fontSize="medium" letterSpacing="0.5px" marginBottom="large">
            What would you like to search?
          </Text>

          <Box
            height={40}
            position="relative"
            variant="white"
          >
            <DashboardSearch isSidebar={parentId === 'sidebar'} resultsBoxProps={{ marginTop: 'small' }} />
          </Box>
        </Box>
      </Image>
    </Box>
  )
}

export default DashboardSearchBox
